module.exports = __webpack_public_path__ + "img/modelo-confeitaria.5e0fae18.png";